import styled from 'styled-components';

export const ModuleStatusListContainer = styled.div`
  & > div.criterion-box {
    margin: 5px 0px;
  }

  & > div.module-empty {
    margin-top: 25vh;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-weight: bold;

    & > svg {
      width: 150px;
      height: 150px;
      position: absolute;
      color: #d1d1d1;
      z-index: 1;
    }

    & > span {
      z-index: 10;
      background: rgb(255, 255, 255, 0.5);
      font-size: 1.3rem;
    }
  }

  & table {
    text-align: center;
    border: 1px solid #000;
    font-size: 2vw;
  }

  & .module-info-tr {
    background: #cbdbe9;
    border-bottom: 1px solid #000;
  }

  & .module-info-tr > td:first-child {
    border-right: 1px solid #000;
  }

  & .module-status-value-tr > td,
  & .criterion-name-tr > td {
    width: 8vw;
    font-size: 1em;
  }

  & .module-status-value-tr > td.module-name-td,
  & .criterion-name-tr > td.module-name-td {
    width: 20vw;
    font-size: 1em;
  }

  & .module-status-value-tr > td.area-status-td,
  & .criterion-name-tr > td.area-status-td {
    width: 10vw;
    padding: 5px 0px;
  }

  & .module-status-value-tr > td.repeater-td {
    width: 40vw;
    padding: 5px 0px;
  }

  & .module-status-value-tr > td.repeater-rssi-td {
    width: 8vw;
    padding: 5px 0px;
  }

  & .module-status-value-tr > td.area-name-td,
  & .criterion-name-tr > td.area-name-td {
    width: 14vw;
    font-size: 1em;
  }

  & .module-status-value-tr > :not(td:last-child),
  & .criterion-name-tr > :not(td:last-child) {
    border-right: 1px solid #000;
  }

  & tr.none {
    background: #959595;
    color: #fff;
  }

  & .module-status-value-tr {
    & > td.blue {
      background: #50bb5b;
    }
    & > td.warning {
      background: #e8b23a;
    }
    & > td.danger {
      background: #ff0018;
    }
    & > td.none,
    & > td.off {
      background: #959595;
    }

    & > td {
      color: #fff;
      background: #424242;

      & > svg {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }
`;

export const AreaBox = styled.div`
  background: #0d5c81;
  color: #fff;
  font-size: 1.3rem;
  margin-top: 10px;
  text-align: center;
`;
